import React from 'react';
import {Navigate} from "react-router-dom";

const AuthRoute = ({children}) => {
    const hasToken = localStorage.getItem('token');
    return !hasToken ? children : <Navigate to={'/dashboard'}/>
};

export default AuthRoute;